import { render, staticRenderFns } from "./folderDeletionComponent.vue?vue&type=template&id=404f8ae0&"
import script from "./folderDeletionComponent.vue?vue&type=script&lang=js&"
export * from "./folderDeletionComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports